import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import images from '../../helpers/images';
import DropDownSelection from '../elements/DropDownSelection';
import InputCheckbox from '../elements/InputCheckbox';
import InputNumber from '../elements/InputNumber';
import RenderErrors from '../elements/RenderErrors';
import FormContext from '../../helpers/formContext';
import store from '../../helpers/store';
import httpService from '../../helpers/httpService';
import sessionService from '../../helpers/sessionService';
import enums from '../../helpers/enums';
import Loader from '../parts/Loader';
import Swal from 'sweetalert2';
import { getUtmString, getGaCid } from '../../helpers/ganalytics';
import helpers from '../../helpers/helpers';
import FormInputs from '../parts/form/FormInputs';


/*** Form Template  ***/
import DefaultTemplate_V2 from '../template/DefaultTemplate_V2';
import LevelupTemplate from '../template/LevelupTemplate';
import SponsorshipTemplate from '../template/SponsorshipTemplate';
import SelfServiceTemplate from '../template/SelfServiceTemplate';

import '../../assets/css/main-central-form.css'
import '../../assets/css/v2/general.css'
import '../../assets/css/v2/donate-form.css'
import '../../assets/css/v2/custom.css'

import { MdNightlightRound, MdSunny } from "react-icons/md";
import { isValidPhoneNumber  } from 'react-phone-number-input'

import PaymentSchedules from '../parts/PaymentSchedules';
 
function MainPageV2 (){
    let { slug } = useParams();
    const base_root = window.location.host;
    const [eye_mode, setMode] = useState(store.site_options.form_mode);
    const [form_data, setFormData] = useState(store.form_data);
    const [apps_token, setAppsToken] = useState(1);
    const [site_options, setOption] = useState(store.site_options);
    const [gaVars, setGaVars] = useState({ ga_client_id: '', utm_codes: '' });
    const [base_url, setBaseUrl] = useState('https://event-api-staging.worldvision.org.ph');
    const [loading, setLoading] = useState(0);
    const [form_loaded, setFormLoaded] = useState(false);
    const [form_slug, setFormSlug] = useState('');
    const [selected_amount, setSelectedAmount] = useState(0);
    const [selected_other_amount, setSelectedOtherAmount] = useState(0);
    const [custom_amount, setCustomAmount] = useState(0);
    const [child_counter, setChildCounter] = useState(1);
    const [number_counter, setNumberCounter] = useState(1);
    const [step, setStep] = useState(1);
    const [min_amount, setMinimumAmount] = useState(0);
    const [errors, setErrors] = useState([]);
    const [count, setCount] = useState(0);
    const [dswd_permit, setDSWD] = useState('DSWD-SB-SP-00044-2022 valid from October 31, 2022 to November 1, 2023; Nationwide.');
    const [banner, setBanner] = useState([]);
    const [loaded, setLoaded] = useState(false);

    const [refresh_schedule, setRefreshSchedule] = useState(Math.random());
    const [schedule_list, setScheduleList] = useState([]);
    const [displayScheduleOptions, setdisplayScheduleOptions] = useState();

    let navigate = useNavigate();
    let checker = useRef(null);
   
    useEffect(() => {
        fetchFormOptions()

        checker.current = setInterval(() => {
            checkGaStuff();
            setCount(prev => prev + 1);
          }, 1000);
        return () => clearInterval(checker.current);
    }, []);

    // useEffect(() => {
    //     const scriptTag = document.createElement("script");
    //     scriptTag.src = "//js.hs-scripts.com/22233274.js?businessUnitId=1237950"
    //     scriptTag.id = "hs-script-loader"
    //     scriptTag.type = "text/javascript";
    //     scriptTag.async = true;
    //     scriptTag.defer = true;
    //     scriptTag.addEventListener('load', ()=>setLoaded(true));
    //     document.head.appendChild(scriptTag);
    // }, []);

    useEffect(() => {
        if(!loaded) return;
    }, [loaded]);

    useEffect(() => {
        if(form_loaded){
            setTimeout(() => {
                const element = document.getElementById('wv-form-inputs');

                const enable_hubspot = site_options?.enable_hubspot ?? 1

                if(element && enable_hubspot){
                    //console.log('Info: Form loaded and hubspot integration is enabled')
                    const scriptTag = document.createElement("script");
                    scriptTag.src = "//js.hs-scripts.com/22233274.js?businessUnitId=1237950"
                    scriptTag.id = "hs-script-loader"
                    scriptTag.type = "text/javascript";
                    scriptTag.async = true;
                    scriptTag.defer = true;
                    scriptTag.addEventListener('load', ()=>setLoaded(true));
                    document.head.appendChild(scriptTag);
                }
            },5000)
        }
    }, [form_loaded]);

    useEffect(() => {
        setDefaultFrequency()

        //setSelectedAmount(0)
        //setSelectedOtherAmount(0)
        //setCustomAmount(0)
        resetSelectedAmount()
    }, [form_data.payment_type]);

    useEffect(() => {
        setDefaultFrequency()
        //getPaymentSchedule()
    }, [
        form_data.payment_method, 
        site_options.payment_methods
    ]);

    useEffect(() => {
        computeTotalAmount()
        //resetSelectedAmount()
    }, [
        selected_amount, 
        custom_amount,
        form_data.payment_frequency,
        site_options,
        child_counter,
        number_counter,
        form_data.addon_items
    ]);

    useEffect(() => {
        let style = {}
        if(site_options.form_background_image){
            style = {
                background: "url(" + site_options.form_background_image + ") no-repeat center center",
                backgroundSize: 'cover'
            }
        }

        let layout_class = ' cf-right-layout'
        const form_position = site_options.form_position;
        if(form_position){
            if(form_position === 'left'){
                layout_class = ' cf-left-layout';
            }
            else if(form_position === 'right'){
                layout_class = ' cf-right-layout';
            }
            else if(form_position === 'center'){
                layout_class = ' cf-center-layout';
            }
        }

        let display_logo = 1;
        //if(site_options.hasOwnProperty('display_logo')){
        if(site_options?.display_logo){
            if(!parseInt(site_options.display_logo)){
                display_logo = 0;
            }
        }
        const banner_section =  <div className={`donation-banner${layout_class}`} style={style}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">    
                                                {
                                                    display_logo ? <div className='wv-logo-container'><img src={images.mainLogoLight} alt="wv-logo" className="wv-logo" /></div> : ''
                                                }
                                                <h1>{site_options.form_content_heading}</h1>
                                            </div>
                                        </div>

                                        <div className='dswd-permit'>{dswd_permit}</div>
                                    </div>
                                </div>
        setBanner(banner_section)
    }, [
        dswd_permit
    ]);
    
    function fetchFormOptions(){
        /**
         * Set production base URL
         */
        let url = base_url;
        //if (base_root == "donate.worldvision.org.ph" || base_root == "www.worldvision.org.ph") {
        if (base_root == "donate.worldvision.org.ph" || base_root == "www.worldvision.org.ph") { // || base_root == "staging-donate.worldvision.org.ph"
            url = 'https://event-api.worldvision.org.ph'
        }
        else if(base_root === 'localhost:3000'){
            //url = 'http://event-api.test'
            //url = 'https://event-api.worldvision.org.ph'
        }
        setBaseUrl(url)

        let url_slug = ''
        const form_slug = document.getElementById("cf-form-slug") ? document.getElementById("cf-form-slug").value : '' // Used in main website
        if(form_slug){
            url_slug = form_slug
        }
        else{
            url_slug = slug;
        }
        setFormSlug(url_slug)

        //if (base_root == "donate.worldvision.org.ph" || base_root == "www.worldvision.org.ph") {
        if (base_root == "donate.worldvision.org.ph" || base_root == "www.worldvision.org.ph") { // || base_root == "staging-donate.worldvision.org.ph"
            if(!url_slug){
                url_slug = 'general-donation'
            }
        }
        else{
            if(!url_slug){
                url_slug = 'general-donation-staging'
            }
            else{
                url_slug += '-staging'
            }
        }

        const api_url = `${url}/module/form`;

        httpService.sendRequest(api_url, "POST", {
            postdata: {
                'slug': url_slug,
                'session_key': sessionService.getSessionToken(sessionKeyName())
            }
        })
        .then((res) => {

            if(res.session != sessionService.getSessionToken(sessionKeyName())){
                sessionService.setSessionToken(res.session, sessionKeyName())
            }

            configureForm(res)
            getDSWDPermit()
        })
        .catch((err) => {
            getDSWDPermit()
            Swal.fire({
                text: err.message,
                icon: 'error',
                confirmButtonText: 'Go to General Donation Form',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    document.location.href="/";
                }
            })
        });
    }

    function configureForm(request){
        let form_fields = {};
        const donor = {...request.donor}
        /** Pre-defined via Get Params */

        // Banner
        let style = {}
        if(request.form_background_image){
            style = {
                background: "url(" + request.form_background_image + ") no-repeat center center",
                backgroundSize: 'cover'
            }
        }

        let layout_class = ' cf-right-layout'
        const form_position = request.form_position;
        if(form_position){
            if(form_position === 'left'){
                layout_class = ' cf-left-layout';
            }
            else if(form_position === 'right'){
                layout_class = ' cf-right-layout';
            }
            else if(form_position === 'center'){
                layout_class = ' cf-center-layout';
            }
        }

        let display_logo = 1;
        //if(request.hasOwnProperty('display_logo')){
        if(request?.display_logo){
            if(!parseInt(request.display_logo)){
                display_logo = 0;
            }
        }
        const banner_section =  <div className={`donation-banner${layout_class}`} style={style}>
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">    
                                                {
                                                    display_logo ? <div className='wv-logo-container'><img src={images.mainLogoLight} alt="wv-logo" className="wv-logo" /></div> : ''
                                                }
                                                <h1>{request.form_content_heading}</h1>
                                            </div>
                                        </div>

                                        <div className='dswd-permit'>{dswd_permit}</div>
                                    </div>
                                </div>
        setBanner(banner_section)

        /** Get Field Names **/
        Object.entries(request.fields).map(([index, data]) => {
            const {field_name, default_value } = data;
            let value =""

            if(default_value){
                value = default_value
            }

            if(field_name === "country"){
                value = "Philippines"
            }

            if(donor[field_name]){
                value = donor[field_name]
            }

            form_fields = { [field_name] : value, ...form_fields }
        })

        if(request?.amount_addons_onetime || request?.amount_addons_recurring){ // One-time
            form_fields.addon_items = []
        }

        let default_payment_type = ''
        let default_payment_method = ''
        //if(request.hasOwnProperty('default_payment_type')){
        if(request?.default_payment_type){
            default_payment_type = parseInt(request.default_payment_type)
        }
        //if(request.hasOwnProperty('default_payment_method')){
        if(request?.default_payment_method){
            default_payment_method = parseInt(request.default_payment_method)
        }
        form_fields.payment_method = default_payment_method
        form_fields.payment_type = default_payment_type
        
        const preload_method = helpers.getURLParams('method')
        if(preload_method == 'cc'){
            form_fields.payment_method = 1
        }
        else if(preload_method == 'paypal'){
            form_fields.payment_method = 2
        }
        else if(preload_method == 'gcash'){
            form_fields.payment_method = 4            
        }
        else if(preload_method == 'other'){
            form_fields.payment_method = 3
        }

        if(default_payment_type == 1){  // One-time
            form_fields.payment_frequency = 1
        }
        else if(default_payment_type == 2){ // Recurring
            if(default_payment_method == 3 || default_payment_method == 4){
                form_fields.payment_frequency = 3 // Quarterly
            }
            else if(default_payment_method){
                form_fields.payment_frequency = 2 // Monthly
            }

            if(preload_method == 'gcash' || preload_method == 'other'){
                form_fields.payment_frequency = "3" // Quarterly
            }
        }

        const preload_partner_id = helpers.getURLParams('partner')
        if(preload_partner_id){
            form_fields.partner_id = preload_partner_id
        }
        else{
            form_fields.partner_id = ""
        }
        
        setFormData({...form_data, ...form_fields})

        
        let minimum_amount = 500;
        //if(request.hasOwnProperty('default_payment_type')){
        if(request?.default_payment_type){
            if(request.default_payment_type == 1){ //one-time
                minimum_amount = request.min_onetime_amount ?? 500;
            }
            else{ //recurring
                minimum_amount = request.min_recurring_amount ?? 750;
            }
        }
        setMinimumAmount(minimum_amount)

        // Update pesopay/paynamics caption to credt card 
        const methods = request.payment_methods;
        methods.forEach(function (value, i) {
            if(value.id === 1 || value.id === 5){
                methods[i].method_name = "Credit / Debit"
            } 
            else if(value.id === 3){
                methods[i].method_name = "Bank / Others"
            } 
        });

        //if(request.hasOwnProperty('form_mode')){
        if(request?.form_mode){
            setMode(request.form_mode)
        }

        /** Set Preload Base Amount */
        const preload_base_amount = helpers.getURLParams('base_amount')
        if(preload_base_amount){
            request.base_onetime_amount = preload_base_amount
            request.base_recurring_amount = preload_base_amount
        }

        setOption(request)
        setFormLoaded(true)
        //setLoading(0)
        setAppsToken(request.apps_token)
    }

    function resetSelectedAmount(){
        const payment_type = parseInt(form_data.payment_type);
        let amount_options = []
        let base_amount = ''

        if(payment_type === 1){ // One-time
            //if(site_options.hasOwnProperty('amount_options_onetime')){
            if(site_options?.amount_options_onetime){
                //if(site_options.amount_options_onetime){
                    amount_options = site_options.amount_options_onetime;
                //}
            }

            //if(site_options.hasOwnProperty('base_onetime_amount')){
            if(site_options?.base_onetime_amount){
                base_amount = parseFloat(site_options.base_onetime_amount);
            }
        }
        else{ //Recurring
            //if(site_options.hasOwnProperty('amount_options_recurring')){
            if(site_options?.amount_options_recurring){
                //if(site_options.amount_options_recurring){
                    amount_options = site_options.amount_options_recurring;
                //}
            }
            
            //if(site_options.hasOwnProperty('base_recurring_amount')){
            if(site_options?.base_recurring_amount){
                base_amount = parseFloat(site_options.base_recurring_amount);
            }
        }

        const preload_amount = helpers.getURLParams('amount')
        if(preload_amount){
            base_amount = parseFloat(preload_amount)
        }

        const preload_base_amount = helpers.getURLParams('base_amount')
        if(preload_base_amount){
            base_amount = parseFloat(preload_base_amount)
        }

        const is_existed = amount_options.find((element) => element == base_amount);
        
        if(preload_amount){
            if(is_existed){
                setSelectedAmount(base_amount)
                setSelectedOtherAmount(0)
                setCustomAmount(0)
            }
            else{
                setSelectedAmount(0)
                setSelectedOtherAmount(1)
                setCustomAmount(base_amount)
            }
        }
        else{
            if(is_existed){
                setSelectedAmount(base_amount)
                setSelectedOtherAmount(0)
                setCustomAmount(0)
            }
        }
    }

    function getDSWDPermit(){
        let url = base_url;
        // if (base_root == "donate.worldvision.org.ph" || base_root == "www.worldvision.org.ph") {
        //     url = 'https://event-api.worldvision.org.ph'
        // }
        url = 'https://event-api.worldvision.org.ph'

        const api_url = `${url}/api/public/get-options?module=general&only=dswd`;

        httpService.sendRequest(api_url, "GET", {})
        .then((res) => {
            //if(res.hasOwnProperty('dswd')){
            if(res?.dswd){
                setDSWD(res.dswd)
            }
        })
        .catch((err) => {
            console.log(err)
        });
    }

    function setDefaultFrequency(){
        let new_state = {}
        let payment_frequency

        if(parseInt(form_data.payment_type) === 1){
            payment_frequency = 1 // One-time
        }
        else if(parseInt(form_data.payment_type) === 2){
            payment_frequency = 2 // Monthly

            if(parseInt(form_data.payment_method) === 3 || parseInt(form_data.payment_method) === 4){
                payment_frequency = 3 // Quarterly
            }
            // else if(form_data.payment_method){
            //     new_state.payment_frequency = "2" // Monthly
            // }

            const preload_method = helpers.getURLParams('method')
            if(parseInt(preload_method) === 'gcash' || parseInt(preload_method) === 'other'){
                payment_frequency = 3 // Quarterly
            }
        }

        setFormData(prev => ({
            ...prev,
            payment_frequency: payment_frequency,
        }));

        // setdisplayScheduleOptions(
        //     <PaymentSchedules
        //         // payment_frequency={payment_frequency}
        //         // payment_method={form_data.payment_method}
        //         // payment_type={form_data.payment_type}
        //     />
        // )
        //setFormData({...form_data, ...new_state})
    }
    
    function changeMode(e, mode){
        e.preventDefault()
        setMode(mode)
    }

    function sessionKeyName(){
        let session_key = 'wvphd-'
        let url_slug = ''
        const form_slug = document.getElementById("cf-form-slug") ? document.getElementById("cf-form-slug").value : '' // Used in main website
        if(form_slug){
            url_slug = form_slug
        }
        else{
            url_slug = slug;
        }

        session_key += url_slug;

        if(!url_slug){
            session_key = 'wvphd-general'
        }

        if (base_root != "donate.worldvision.org.ph" && base_root != "www.worldvision.org.ph") {
            session_key += '-staging'
        }

        return session_key;
    }

    function checkGaStuff() {

        let gaValues = {};

        if (!gaVars.utm_codes) {
            gaValues.utm_codes = getUtmString();
        }

        if (!gaVars.ga_client_id) {
            gaValues.ga_client_id = getGaCid();
        }

        if (gaValues.utm_codes || gaValues.ga_client_id) {
            setCount(0);
            clearInterval(checker.current);

            setGaVars({
                ...gaVars,
                ...gaValues
            });
        }
    }

    function selectPaymentType(payment_type) {
        // --- Constants for clarity ---
        const PAYMENT_TYPE = {
            ONETIME: 1,
            RECURRING: 2,
        };

        const paymentTypeNum = parseInt(payment_type);
        let minimumAmount = 0;
        
        // Initialize new state with the primary change
        const newState = {
            payment_type: paymentTypeNum,
        };

        // --- Destructuring for cleaner access ---
        const {
            min_onetime_amount,
            min_recurring_amount,
            payment_methods: availableMethods,
            default_payment_method
        } = site_options;

        // --- 1. Set Minimum Amount based on Payment Type ---
        if (paymentTypeNum === PAYMENT_TYPE.ONETIME) {
            minimumAmount = min_onetime_amount;
        } else if (paymentTypeNum === PAYMENT_TYPE.RECURRING) {
            minimumAmount = min_recurring_amount;
        }
        
        // --- 2. Centralized Form Field Reset ---
        // Reset campaign-related or additive fields if they exist in the current form data.
        const fieldsToReset = [
            { key: 'addon_items', defaultValue: [] },
            { key: 'campaigns', defaultValue: '' },
            { key: 'campaign', defaultValue: '' },
            { key: 'campaign_specific', defaultValue: '' }
        ];

        fieldsToReset.forEach(({ key, defaultValue }) => {
            // Check if the field exists in form_data before resetting
            if (form_data?.[key] !== undefined) {
            newState[key] = defaultValue;
            }
            
            // For Self Service DC Template only
            if((key == 'campaign' || key == 'campaigns') && payment_type == 2 && site_options.form_template == 'self-service-dc'){
                const target_field = helpers.filterObject(site_options.fields, key, 'field_name')

                newState[key] = target_field?.default_value ?? defaultValue;
            }
        });

        // --- 3. Validate and Update Payment Method ---
        const selectedPaymentMethod = form_data.payment_method;
        
        // Find configuration for the currently selected payment method
        const paymentMethodConfig = helpers.filterObject(availableMethods, selectedPaymentMethod);
        
        // Use Optional Chaining (?.) and Nullish Coalescing (??)
        const visibility = paymentMethodConfig?.visibility ?? []; 

        // Check if the new payment type is *not* visible for the current payment method
        if (!visibility.includes(paymentTypeNum)) {
            // Set the payment method to the site's default
            newState.payment_method = parseInt(default_payment_method);
        }

        // --- 4. Final State Updates ---
        // Update the minimum amount state
        setMinimumAmount(minimumAmount);

        // Safely merge the new state changes into the form data
        setFormData(prevFormData => ({
            ...prevFormData,
            ...newState
        }));
    }

    function selectPaymentTypeOld(payment_type){
        let base_amount = 0
        let minimum_amount = 0
        let new_state = { 'payment_type': payment_type }

        if(parseInt(payment_type) === 1){
            base_amount = site_options.base_onetime_amount
            minimum_amount = site_options.min_onetime_amount
            //new_state.payment_frequency = 1 // One-time
        }
        else if(parseInt(payment_type) === 2){
            base_amount = site_options.base_recurring_amount;
            minimum_amount = site_options.min_recurring_amount
        }

        if(form_data?.addon_items){
            new_state['addon_items'] = []
        }
        if(form_data?.campaigns){
            new_state['campaigns'] = ''
        }
        if(form_data?.campaign){
            new_state['campaign'] = ''
        }
        if(form_data?.campaign_specific){
            new_state['campaign_specific'] = ''
        }

        const selected_payment_method = form_data.payment_method;
        const methods = site_options.payment_methods;
        const payment_methods = helpers.filterObject(methods, selected_payment_method)
        const visibility = payment_methods?.visibility ?? [] //Payment Type Visibility

        if(!visibility.includes(parseInt(payment_type))){// Prevent Displaying Method
            const default_payment_method = parseInt(site_options.default_payment_method)
            new_state['payment_method'] = default_payment_method

            // if(parseInt(payment_type) === 1){
            //     new_state['payment_frequency'] = 1 //Onetime
            // }
            // else{
            //     new_state['payment_frequency'] = 2 //Monthly

            //     if(default_payment_method == 3 || default_payment_method == 4){
            //         new_state['payment_frequency'] = 3 //Quarterly
            //     }
            // }

        }

        setMinimumAmount(minimum_amount)
        setFormData({ ...form_data, ...new_state });
    }

    function getPaymentSchedule() {
        const method_id = form_data.payment_method
        const methods = site_options.payment_methods;

        if(methods){
            let obj = methods.find(o => o.id == method_id);

            if(obj){
                setScheduleList(obj.payment_schedules)
            }
        }
    }

    function displayPaymentTypeHandles(){
        let buttons = []

        buttons = Object.entries(site_options.payment_types).map(([index, data]) => {
            let is_selected = '';
            if(form_data.payment_type == data.value){
                is_selected = 'checked';
            }
            
            return (
                <div className="rb-list-item" key={`payment-types-${index}`}>
                    <input type="radio" name="payment_type" defaultChecked={is_selected} onClick={(e) => selectPaymentType(data.value)} />
                    <span className="rb-list-label">{data.type_name}</span>
                </div>
            )
        });
        
        if(Object.keys(site_options.payment_types).length > 1){
            return (
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="rbuttons">
                            {buttons}
                        </div>
                    </div>
                </div>
            )
        }
    }

    function displayPaymentMethodHandles(errors){
        let buttons = []

        let classes = 'rbuttons2 d-lg-flex justify-content-start flex-nowrap'
        let item_class = 'rb-list-item me-1 me-lg-2'
        //if(site_options.payment_methods.length == 3){
            //classes += ' d-lg-flex justify-content-start'
            //item_class += ' me-1 me-lg-2'
        //}

        const total_method = site_options.payment_methods.length
        buttons = Object.entries(site_options.payment_methods).map(([index, data]) => {
            let is_selected = '';
            if(parseInt(form_data.payment_method) === data.id){
                is_selected = ' selected';
            }

            const visibility = data?.visibility ?? [1,2] //Payment Type Visibility
            if(!visibility.includes(parseInt(form_data.payment_type))){// Prevent Displaying Method
                return
            }

            const count = parseInt(index) + 1;

            if(count === total_method){
                item_class = 'rb-list-item'
            }

            return (
                <span className={item_class}>
                    <input type="radio" name="payment_method" value={data.id} defaultChecked={is_selected} className={`payment-method-${data.id}`}  onChange={inputChange} />
                    <span className={`rb-list-label${is_selected}`}>{data.method_name}</span>
                </span>
            )
        })

        return (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <h3 className='fs-5'>Giving Method</h3>
                <span className={classes}>
                    {buttons}
                </span>
                <RenderErrors 
                    errors={errors} 
                    name="payment_method"
                    className="text-error fs-7"
                />
            </div>            
        )
    }

    function displayPaymentScheduleHandles(){
        let items = []

        let classes = 'rbuttons4'
        let item_class = 'rb-list-item'
        if(schedule_list.length == 3){
            classes += ' d-lg-flex justify-content-lg-start'
            item_class += ' me-md-1 me-lg-2'
        }

        items = Object.entries(schedule_list).map(([index, data]) => {
            let is_selected = '';
            if(form_data.payment_frequency == data.id){
                is_selected = ' selected';
            }

            return (
                <span className={item_class}>
                    <input type="radio" name="payment_frequency" defaultValue={data.id} onChange={inputChange} />
                    <span className={`rb-list-label${is_selected}`}>{helpers.ucwords(data.text)}</span>
                </span>
            )
        })

        if(Object.keys(items).length > 1){
            return (     
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <h3 className='fs-5'>Schedule</h3>
                        <span className={classes}>
                            {items}
                        </span>
                        <RenderErrors 
                            errors={errors} 
                            name="payment_frequency"
                            className="text-error fs-7"
                        />
                    </div>  
                </div>   
            )
        }
    }

    function displaySelectedFrequency(){
        let result = ''

        if(form_data.payment_type == 1){
            let suffix = 'One-Time' //default
            //if(site_options.hasOwnProperty('amount_suffix_type') || site_options.hasOwnProperty('amount_suffix_divisor') || site_options.hasOwnProperty('amount_suffix_text')){
            if(site_options?.amount_suffix_type || site_options?.amount_suffix_divisor || site_options?.amount_suffix_text){
                if(site_options.amount_suffix_type == 'text-only'){
                    suffix = `${site_options.amount_suffix_text}`;
                }
                else if(site_options.amount_suffix_type == 'number-with-text'){
                    const divisor = site_options.amount_suffix_divisor ?? 0;
                    let quotient = Number(form_data.amount) / Number(divisor);
                    
                    if(Number.isInteger(quotient)){
                        suffix = `${quotient} ${site_options.amount_suffix_text}`
                    }
                }
            }

            result += form_data.payment_frequency ? suffix: '';
        }
        else{
            let payment_frequency = form_data.payment_frequency;
            if(payment_frequency  && payment_frequency !== 1){
                result += `${helpers.ucwords(enums.paymentFrequency(payment_frequency))}`
            }
            else{
                //result = '';
            }
        }

        return result;
    }

    function displayAmountAddons(){
        let buttons = []
        let amount_addons = []
        let classes = 'rbuttons4 amount-buttons'
        let item_class = 'rb-list-item mb-2 mb-lg-0'
        
        if(form_data.payment_type == 1){ // One-time
            if(site_options?.amount_addons_onetime){
                amount_addons = site_options.amount_addons_onetime
            }
        }
        else{ //Recurring
            if(site_options?.amount_addons_recurring) {
                amount_addons = site_options.amount_addons_recurring
            }
        }

        if(amount_addons.length <= 3){
            classes += ' d-lg-flex justify-content-lg-start'
            item_class += ' me-md-1 me-lg-2'
        }

        buttons = Object.entries(amount_addons || []).map(([index, data]) => {
            let is_selected = ''
            const added = helpers.isItemAlreadyAdded(form_data.addon_items, data, ['id'])
            if(added) is_selected = ' selected'

            return (
            <div className={item_class} key={`amount-addons-${index}`}>
                <input type="radio" name="payment_frequency" defaultValue={data.value} onClick={(e) => selectAmountAddon(data)} />
                <div className={`rb-list-label${is_selected}`}>
                    &#8369;{getFormatAmount(data.value)}
                    <div className='sub-label'>{data.label}</div>
                </div>
            </div>
            )
        })
        
        if(buttons.length){
            return (
                <div>
                    <h3 className='fs-5'>Add-on</h3>
                    
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <span className={classes}>
                                {buttons}
                            </span>
                        </div>
                    </div> 
                </div>           
            )
        }
    }
    
    function displayAmountHandles(){
        let amount_options = []
        let buttons = []
        
        if(parseInt(form_data.payment_type) === 1){ // One-time
            //if(site_options.hasOwnProperty('amount_options_onetime')){
            if(site_options?.amount_options_onetime){
                //if(site_options.amount_options_onetime){
                    amount_options = site_options.amount_options_onetime;
                //}
            }
        }
        else{ //Recurring
            //if(site_options.hasOwnProperty('amount_options_recurring')){
            if(site_options?.amount_options_recurring){
                //if(site_options.amount_options_recurring){
                    amount_options = site_options.amount_options_recurring;
                //}
            }
        }

        let classes = 'rbuttons4 amount-buttons'
        let item_class = 'rb-list-item mb-2 mb-lg-0'
        if(amount_options.length <= 3){
            classes += ' d-lg-flex justify-content-lg-start'
            item_class += ' me-md-1 me-lg-2'
        }

        if(amount_options){
            buttons = Object.entries(amount_options).map(([index, data]) => {
                if(helpers.detectType(data) === 'object'){
                    let is_selected = '';
                    if(selected_other_amount == 0 && data.value == selected_amount){
                        is_selected = '  selected';
                    }

                    return (
                    <div className={item_class} key={`amount-handle-${index}`}>
                        <input type="radio" name="payment_frequency" defaultValue={data.value} onClick={(e) => selectAmountOption(data.value)} />
                        <div className={`rb-list-label${is_selected}`}>
                            &#8369;{getFormatAmount(data.value)}
                            <div className='sub-label'>{data.sub_label}</div>
                        </div>
                    </div>
                    )
                }
                else{
                    let is_selected = '';
                    if(selected_other_amount == 0 && data == selected_amount){
                        is_selected = '  selected';
                    }

                    return (
                    <div className={item_class} key={`amount-handle-${index}`}>
                        <input type="radio" name="payment_frequency" defaultValue={data} onClick={(e) => selectAmountOption(data)} />
                        <div className={`rb-list-label${is_selected}`}>
                            &#8369;{getFormatAmount(data)}
                        </div>
                    </div>
                    )
                }
            });
        }
        
        /** Other Amount **/
        let is_selected = '';
        if(selected_other_amount){
            is_selected = ' selected';
        }

        let show_other_amount  = 1;
        if(parseInt(form_data.payment_type) === 1){ // One-time
            //if(site_options.hasOwnProperty('other_amount_onetime')){
            if(site_options?.other_amount_onetime){
                show_other_amount = parseInt(site_options.other_amount_onetime);
            }
        }
        else{ //Recurring
            //if(site_options.hasOwnProperty('other_amount_recurring')){
            if(site_options?.other_amount_recurring){
                show_other_amount = parseInt(site_options.other_amount_recurring);
            }


        }

        if(show_other_amount){
            buttons.push(
                <span className="rb-list-item last" key="amount-handle-other">
                    <input type="radio" name="payprice" defaultValue="Other Amount" onClick={(e) => selectAmountOption('other')} />
                    <span className={`rb-list-label${is_selected}`}>Other Amount</span>
                </span>
            )
        }

        if(buttons.length){
            return (
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <span className={classes}>
                            {buttons}
                        </span>
                    </div>
                </div>            
            )
        }
    }

    function selectAmountOption(amount){
        if(amount !== 'other'){
            setSelectedAmount(amount)
            setCustomAmount(0)
            setSelectedOtherAmount(0)
        }
        else{
            setSelectedAmount(0)
            setCustomAmount(0)
            setSelectedOtherAmount(1)
        }
    }

    function selectAmountAddon(newAddon){
        setFormData(prevForm => {
            const exists = prevForm.addon_items.some(
                item => item.id === newAddon.id
            );

            let updatedAddons = []
            if(exists){
                updatedAddons = prevForm.addon_items.filter(
                    item => item.id !== newAddon.id
                )
            }else{
                updatedAddons = [...prevForm.addon_items, newAddon];
            }

            return {
            ...prevForm,
            addon_items: updatedAddons
            };
        });
    }

    function computeTotalAmount(){
        let base_amount = 500
        let total = 0;
        let payment_frequency = form_data.payment_frequency
        let new_state = {}
        let total_child = child_counter;
        let total_counter = number_counter;

        if(selected_amount && !custom_amount){
            base_amount = selected_amount;
        }
        else if(custom_amount && !selected_amount){
            base_amount = custom_amount;
        }
        else if(form_data.payment_type == 1){
            base_amount = site_options.base_onetime_amount;
        }
        else if(form_data.payment_type == 2){
            base_amount = site_options.base_recurring_amount;
        }

        if(form_data.payment_type == 1){
            total_child = 1;
            payment_frequency = 1;
        }

        if(form_data?.addon_items){  
            base_amount = parseFloat(base_amount) + helpers.sumByKey(form_data?.addon_items, 'value')
        }

        switch (parseInt(payment_frequency, 10)) {
            case 2: // monthly
                total = base_amount * 1;
                break;
            case 3: // quarterly
                total = base_amount * 3;
                break;
            case 4: // semi-annually
                total = base_amount * 6;
                break;
            case 5: // annually
                total = base_amount * 12;
                break;
            default:
                total = base_amount * 1;
        }

        //new_state.amount = total;
        new_state.amount = total * total_child * total_counter;

        if(selected_other_amount && !custom_amount){
            new_state.amount = 0
        }

        setFormData({...form_data, ...new_state})
    }

    function getFormatAmount(amount){
        let total = amount;
        var num_parts = amount.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "");
        total = num_parts.join(".");
        if(!isNaN(total)){
            total = Number(total).toFixed(2)
        }
        total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return total;
    }

    function displayReviewFields(){
        let review_fields = []

        review_fields = Object.entries(site_options.fields).map(([index, data]) => {
            const {field_name, field_label, custom_field_label} = data;
            const label = custom_field_label ?? field_label

            let classname = 'col-lg-6 mb-3'
            if(field_name === 'complete_addres'){
                classname = 'col-lg-12 mb-3'
            }

            return (
                <div key={index} className={classname}>
                    <label className="form-label">{label}</label>
                    <h4 className='fw-bold text-break mb-0 form-value'>{form_data[field_name] ? form_data[field_name] : '---'}</h4>
                </div>            
            )
        })

        return review_fields;
    }

    function inputChange(e) {
        // let { name, value } = e.target;

        // if (e.target.type === "checkbox") {
        //     if (e.target.checked) {
        //         value = 1;
        //     } else {
        //         value = 0;
        //     }
        // }

        // let new_state = { [name]: value }
        // setFormData({ ...form_data, ...new_state });
        const { name, type, checked, value: rawValue } = e.target;
        const value = type === "checkbox" ? (checked ? 1 : 0) : rawValue;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    }

    function inputChangeAmount(e, options) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        const obj = helpers.filterObject(options, value, "id")
        //if(obj.hasOwnProperty('amount')){
        if(obj?.amount){
             setSelectedAmount(obj.amount)            
             setCustomAmount(0)
             setSelectedOtherAmount(0)
        }

        let new_state = { [name]: value }

        setFormData({ ...form_data, ...new_state });
    }
    
    function inputCustomAmount(e) {
        let { value, name } = e.target;

        let new_state = { [name]: value }

        setCustomAmount(value)
        setSelectedAmount(0)
        setFormData({ ...form_data, ...new_state });
    }

    function inputChildCounter(e) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;
            } else {
                value = 0;
            }
        }

        if(!isNaN(Number(value))){
            if(value > 100) value = 100;

            setChildCounter(value);

            let new_state = {}
            new_state.no_of_child = value;
            setFormData({...form_data, ...new_state})
        }
    }
    function inputNumberCounter(e) {
        let { value, name } = e.target;

        if(!isNaN(Number(value))){
            setNumberCounter(value);

            let new_state = {}
            new_state.number_counter = value;
            setFormData({...form_data, ...new_state})
        }
    }

    function inputFocus(e) {
        removeErrors(e)
    }

    function removeErrors(e){
        let { name } = e.target;
        let newErrors = {...errors}

        delete newErrors[name];

        setErrors(newErrors);
    }

    function validateForm(e){
        let new_errors = {...errors}

        if(!form_data.amount){
            new_errors['amount'] = ["Total amount field is required."]
        }
        else if(form_data.amount && Number(form_data.amount) < Number(min_amount)){
            new_errors['amount'] = [`Total amount must be at least ₱${getFormatAmount(min_amount)}.`]
        }
        else{
            delete new_errors['amount'];
        }

        if(!form_data.payment_method){
            new_errors['payment_method'] = ["The giving method field is required."]
        }else{
            delete new_errors['payment_method'];
        }

        if(!form_data.payment_frequency){
            new_errors['payment_frequency'] = ["The payment frequency field is required."]
        }else{
            delete new_errors['payment_frequency'];
        }

        //Data Privacy
        if(!form_data.agree_to_privacy_policy){
            new_errors['agree_to_privacy_policy'] = ["The agree to privacy policy must be accepted."]
        }else{
            delete new_errors['agree_to_privacy_policy'];
        }

        /**
         * Dynamically check fields
         */
        if(Object.keys(site_options.fields).length){
            Object.entries(site_options.fields).map(([index, data]) => {
                let {field_name, is_required} = data;
                if(is_required){
                    if(!form_data[field_name]){
                        new_errors[field_name] = [`The ${field_name.replace(/_/g, " ")} field is required.`]
                    }
                    else if(field_name == 'mobile_no' && !isValidPhoneNumber(form_data[field_name])){
                        new_errors[field_name] = [`Invalid mobile number. Please retry.`]
                    }
                    // else if(field_name == 'mobile_no' && form_data[field_name].length != 11){
                    //     //new_errors[field_name] = [`Invalid ${field_name.replace(/_/g, " ")}. Please retry`]
                    //     new_errors[field_name] = [`Invalid mobile number. Please retry.`]
                    // }
                    else{
                        delete new_errors[field_name];
                    }
                }
                else{
                    delete new_errors[field_name];
                }

                //Form Self serivce DC Template only and payment type is recurring, remove campaign error if any
                if(field_name == 'campaign' && site_options?.form_template == 'self-service-dc' && form_data.payment_type == 2){
                    console.log('remove campaign error')
                    delete new_errors[field_name];
                }
            });
        }

        setErrors(new_errors);

        return new_errors;
    }

    function formController(new_step){

        const validate = validateForm();

        console.log(validate)

        if(Object.keys(validate).length){
            let message = 'Please check your inputs and try again.'

            //if(validate.hasOwnProperty('amount')){
            if(validate?.amount){
                message = validate['amount'];
            }

            setLoading(0)
            Swal.fire({
                text: message,
                icon: "error",
                confirmButtonText: "OK",
            });

            if(step !== new_step){
                setStep(1)
            }

            return;
        }
       
        if(site_options.form_type === 'direct-checkout'){
            transact()
        }
        else{ // Review detail => Checkout
            if(new_step === 2){
                transact()
            }
            
            setTimeout(() => {
                setStep(new_step)
            },50)
        }
    }

    function transact(){
        setLoading(1)

        let new_form_data = {...form_data}
        //if(site_options.hasOwnProperty('child_counter')){
        if(site_options?.child_counter){
            if(parseInt(site_options.child_counter) === 0){
                new_form_data.no_of_child = 0;
            }
        }
        else{
            new_form_data.no_of_child = 0;
        }

        //if(site_options.hasOwnProperty('number_counter')){
        if(site_options?.number_counter){
            if(parseInt(site_options.number_counter) === 0){
                new_form_data.number_counter = 0;
            }
        }
        else{
            new_form_data.number_counter = 0;
        }
        
        let post_data = {
            ...new_form_data, 
            ...gaVars,
            'apps_token': apps_token,
            'session_key': sessionService.getSessionToken(sessionKeyName()),
        }

        const api_url = `${base_url}/module/transact`;

        httpService.sendRequest(api_url, "POST", {
            postdata: post_data
        })
        .then((res) => {
            setLoading(0)

            if(res.session != sessionService.getSessionToken(sessionKeyName())){
                sessionService.setSessionToken(res.session, sessionKeyName())
            }

            if(res.status === 'success'){
                if(site_options.form_type === 'direct-checkout'){
                    checkOut()
                }
            }
        })
        .catch((err) => {
            console.log(err)
            setLoading(0)

            if(err.data){
                setErrors( err.data );
                err.message = "Please check your inputs and try again.";
                setStep(1)
            }else{
                setErrors([])
            }

            Swal.fire({
                text: err.message,
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false
            })
        });
    }

    function checkOut(){
        setLoading(1)
        const validate = validateForm();

        if(Object.keys(validate).length){
            let message = 'Please check your inputes and try again.'

            //if(validate.hasOwnProperty('amount')){
            if(validate?.amount){
                message = validate['amount'];
            }

            Swal.fire({
                //title: "Error!",
                text: message,
                icon: "error",
                confirmButtonText: "OK",
            });

            setStep(1)

            return;
        }

        const api_url = `${base_url}/module/checkout`;

        httpService.sendRequest(api_url, "POST", {
            postdata: {
                'apps_token': apps_token,
                'session_key': sessionService.getSessionToken(sessionKeyName()),
            }
        })
        .then((res) => {
            setLoading(0)
            if(res.status === 'success'){
                sessionService.removeSessionToken(sessionKeyName())

                if(form_data.payment_method == 3){ //Manual Payment
                    Swal.fire({
                        title: 'Thank you!',
                        text: 'Instructions on how to send your donation have been sent to the e-mail you provided.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setTimeout(() => {
                                return navigate('/manual-instruction?home='+window.location.href);
                            }, 1000);
                        }
                    })
                }
                else {
                    let text = ''
                    if(form_data.payment_method == 1 || form_data.payment_method == 4){
                        text = 'Pesopay is a secure payment portal which will allow you to safely register your Credit/Debit Card or Gcash details.'
                    }else if(form_data.payment_method == 2){
                        text = 'Paypal is a secure payment portal which will allow you to safely register your payment details'
                    }else if(form_data.payment_method == 5){
                        text = 'Paynamics is a secure payment portal which will allow you to safely register your payment details'
                    }
                
                    Swal.fire({
                        title: 'Redirecting to Payment gateway please wait...',
                        text: text,
                        icon: 'info',
                        allowOutsideClick: false,
                        showCancelButton: false, // There won't be any cancel button
                        showConfirmButton: false // There won't be any confirm button
                    });

                    const body = document.getElementsByTagName("body")[0];
                    const div = document.createElement("div");
                    div.setAttribute("class", "hidden");
                    div.innerHTML = res.form;
                    body.appendChild(div);

                    setTimeout(() => {
                        document.getElementById("payment-gateway").submit();
                    }, 2000);
                }

            }

        })
        .catch((err) => {
            console.log(err)
            setLoading(0)

            Swal.fire({
                // title: 'Error!',
                text: err.message,
                icon: 'error',
                confirmButtonText: 'Refresh Form',
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    clearAllData()
                }
            })
        });
    }

    function clearAllData(){
        sessionService.removeSessionToken(sessionKeyName())
        setStep(1)
        //setFormLoaded(0)
        fetchFormOptions()
    }

    function parentClass(preclass=''){
        let classes = preclass + ' ' + eye_mode + ' cf-main'
        const form_position = site_options.form_position;
        //cf-main cf-left-layout
        if(form_position){
            if(form_position === 'left'){
                classes += ' cf-left-layout';
            }
            else if(form_position === 'right'){
                classes += ' cf-right-layout';
            }
            else if(form_position === 'center'){
                classes += ' cf-center-layout';
            }
        }else{
            classes += ' cf-right-layout';
        }
        
        return classes
    }

    function addChildCount(){
        let new_state = {}
       if(!isNaN(Number(form_data.no_of_child))){
            let count = Number(form_data.no_of_child) + 1;

            if(count > 50) count = 50;

            setChildCounter(count)

            new_state.no_of_child = count;
            setFormData({...form_data, ...new_state})
       }
    }

    function removeChildCount(){
        let new_state = {}
        if(!isNaN(Number(form_data.no_of_child))){
            let count = Number(form_data.no_of_child) - 1;
            
            if(count < 1) count = 1;

            setChildCounter(count)

            new_state.no_of_child = count;
            setFormData({...form_data, ...new_state})
        }
    }

    function addNumberCount(){
        let new_state = {}
       if(!isNaN(Number(form_data.number_counter))){
            let count = Number(form_data.number_counter) + 1;

            setNumberCounter(count)

            new_state.number_counter = count;
            setFormData({...form_data, ...new_state})
       }
    }

    function removeNumberCount(){
        let new_state = {}
        if(!isNaN(Number(form_data.number_counter))){
            let count = Number(form_data.number_counter) - 1;
            
            if(count < 1) count = 1;

            setNumberCounter(count)

            new_state.number_counter = count;
            setFormData({...form_data, ...new_state})
        }
    }

    function FormTemplateController (){
        let classes = 'cf-form-container ' + eye_mode
        const form_template = site_options.form_template ?? 'default';
        let layout = <DefaultTemplate_V2 />

        if(form_template === 'level-up'){
            layout = <LevelupTemplate />
        }
        else if(form_template === 'sponsorship'){
            layout = <SponsorshipTemplate />
        }
        else if(form_template === 'self-service-dc'){
            layout = <SelfServiceTemplate />
        }

        if (base_root != "www.worldvision.org.ph" && base_root != "dev-site.worldvision.org.ph" && base_root != "wordpress-1128592-4136132.cloudwaysapps.com") {
            classes += ' col-sm-12 col-md-12 col-lg-6 col-xl-6 df-col2'

            return (
                <div className="container-fluid p-0">
                    {
                        banner
                    }

                    <div className="donation-content">
                        <div className="container">
                            <div className={parentClass('row donation-form-wrapper flex justify-content-between')}> 
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-5 df-col1 cf-description-column">

                                    <div className="donation-inner">
                                        {site_options.form_content_heading ? <h1>{site_options.form_content_heading}</h1> :  <h1>{site_options.form_heading}</h1>}

                                        {site_options.form_content_body ? 
                                            <div dangerouslySetInnerHTML={{__html: site_options.form_content_body}} /> : 
                                            <>
                                                <p>When you give where it’s needed most you’ll help Filipino children and their communities rise above poverty. Because it’s life-changing when you finally have clean water, get the right kind of food, feel safe, learn in a classroom, or grow spiritually and discover that you are loved, known and cared for.</p>
                                                <p className="color-orange"><h3>Let’s maximize your impact!</h3></p>
                                                <p>Your gift will go where it will make the biggest difference, meeting urgent needs that might otherwise go unmet.</p>
                                                <p>At World Vision, stewardship is an integral part of everything we do. In rare cases where donations exceed what is needed, or where local conditions prevent program implementation, World Vision will redirect funds to similar activities to help children and families in need.</p>
                                            </>
                                        }
                                    </div>
                                </div>   

                                <div className={classes}>
                                    {layout}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>             
            )
        }

        return (
            <div className='donation-content cf-form-only'>
                <div className={classes}>
                    {layout}
                </div>
            </div>
        )
    }

    return (
    <>
        <FormContext.Provider value={{
            inputCustomAmount,
            checkOut,
            parentClass, 
            displayPaymentTypeHandles,
            displayAmountHandles,
            displaySelectedFrequency,
            displayPaymentMethodHandles,
            displayPaymentScheduleHandles,
            getFormatAmount,
            inputChange,
            enums,
            helpers,
            custom_amount, 
            selected_other_amount,
            schedule_list,
            formController,
            displayReviewFields,
            eye_mode, changeMode,
            form_data, setFormData,
            site_options, setOption,
            apps_token, setAppsToken,
            gaVars, setGaVars,
            form_loaded,
            loading,
            step, setStep,
            errors, setErrors, removeErrors,
            images,
            Loader,
            RenderErrors,
            DropDownSelection,
            InputNumber,
            //FormInputs,
            InputCheckbox,
            MdNightlightRound, MdSunny,
            addChildCount,
            removeChildCount,
            child_counter, 
            setChildCounter,
            inputChildCounter,
            dswd_permit, 
            setDSWD,
            banner,
            number_counter,
            inputNumberCounter,            
            addNumberCount,
            removeNumberCount,
            form_slug,
            inputChangeAmount,
            displayAmountAddons,
            refresh_schedule,


            displayScheduleOptions,
            selectPaymentType
        }}>

            {!form_loaded ?
            <section className={parentClass()} style={{background:"transparent"}}>
                    <div className='d-flex justify-content-center'>
                        <div style={{position: 'relative', background:'rgba(20, 20, 20, 0.8)', padding: '10px 15px', marginTop: '20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px'}} className='text-center'>
                            <h3 style={{margin: '0px 10px 0px 0px', marginBottom: '0px', color: '#fff'}}>Initializing form</h3>
                            <img src={images.rollin} style={{width: '30px', height: '30px'}}/>
                        </div>
                    </div>
            </section> : ''}

            {/* {form_loaded ?
                <section className={parentClass()} style={{backgroundColor: 'transparent', paddingTop: '20px'}}>
                    <div className='d-flex justify-content-center'>
                            <div className="col-lg-6s">
                                <div className="cf-form-container" style={{position: 'relative'}}>
                                    <Loader isLoading={loading} />
                                    <div className="text-center">
                                        <h3>Initializing form...</h3>
                                    </div>
                                </div>
                            </div>

                    </div>
                </section> : ''
            } */}

            {form_loaded && FormTemplateController()}
        </FormContext.Provider>
    </>
    )
}
 
export default MainPageV2;